import React from 'react';
import { useTranslation } from 'react-i18next';
import { FontWeight, Heading, LiliButton, Text } from '@lili/lili-frontend-common';
import { ReactComponent as GustoIcon } from '../../../assets/svg/vendors/gusto-icon.svg';
import GustoWidget from '../../DashboardFacelift/widgets/GustoWidget/GustoWidget';

interface IGustoConnectAccountProps {
  onConnectClick: () => void;
  isLoading: boolean;
}

const GustoConnectYourAccount = ({ onConnectClick, isLoading }: IGustoConnectAccountProps) => {
  const { t } = useTranslation();
  return (
    <div
      data-testid='GustoApp__card-status-unconnected'
      className='w-[552px] h-[568px] bg-bw00 rounded-[8px] px-[40px] pt-[33px] pb-[29px] flex flex-col justify-between shadow-widgetCard'
    >
      <div className='w-full'>
        <div className='flex items-center'>
          <div className='mr-[10px] flex items-center justify-center w-[36px] h-[36px]'>
            <GustoIcon className='rounded-[6px]' />
          </div>
          <div className='flex flex-col justify-center'>
            <Heading.H10 fontWeight={FontWeight.MEDIUM} className='text-text-main-disabled'>
              {t('GUSTO.FIRST_STEP.STEP')}
            </Heading.H10>
            <Heading.H7 data-testid='GustoApp__unconnected-title' fontWeight={FontWeight.MEDIUM}>
              {t('GUSTO.FIRST_STEP.TITLE')}
            </Heading.H7>
          </div>
        </div>
        <Text.H9 data-testid='GustoApp__unconnected-subtitle' className='mt-[16px] mb-[57px]'>
          {t('GUSTO.FIRST_STEP.SUBTITLE')}
        </Text.H9>
        <div className='w-full h-[209px] bg-bw03 flex items-center justify-center'>
          <GustoWidget isMockMode />
        </div>
      </div>
      <LiliButton
        title={t('GUSTO.FIRST_STEP.BUTTON')}
        id='GustoApp__connect-btn'
        className='w-[280px] h-[50px] self-center'
        onClick={onConnectClick}
        isLoading={isLoading}
      />
    </div>
  );
};

export default GustoConnectYourAccount;
